import { sendRequest } from 'api/sendRequest';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { endpoints } from 'constants/endpoints';

import { OneOnOneLandingPageRequestI } from '../interfaces/common';

export const getOneOnOneLandingPageApi = ({
  isArchivedList,
  dateRange,
  selectedCohortId,
  isShowReportees,
  employeedId,
}: OneOnOneLandingPageRequestI) => {
  const url = endpoints.oneOnOneRevamped.landingPage;
  const timestampDateRange = {
    startTS: dateRange.startDate.getTime(),
    endTS: dateRange.endDate.getTime(),
  };
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: selectedCohortId,
      dateRange: timestampDateRange,
      groupByKeys: null,
      orderBy: null,
    },
    queryParams: {
      isArchivedList,
      isShowReportees,
      emp_id: employeedId,
    },
  });
};

export const getOneOnOneActiveArchiveCountApi = ({ selectedCohortId, dateRange }) => {
  const url = endpoints.oneOnOneRevamped.activeArchiveCount;
  const timestampDateRange = {
    startTS: dateRange.startDate.getTime(),
    endTS: dateRange.endDate.getTime(),
  };
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: selectedCohortId !== null && {
      cohortId: selectedCohortId,
      dateRange: timestampDateRange,
      groupByKeys: null,
      orderBy: null,
    },
    queryParams: {
      includeReportees: !checkNewNavEnabled(),
    },
  });
};
